<template>
  <div class="package-editor">
    <div class="row">
      <div class="col image-container">
        <label class="label">รูป Icon</label>
        <img :src="modalImageUrl" class="thumbnail" />
        <sc-button
          class="thumbnail-button"
          @click="handleClickChooseImageButton"
          >เลือกรูป Icon</sc-button
        >
      </div>
      <div class="col info-editor">
        <label class="label">ชื่อ</label>
        <el-input v-model="name" class="input"></el-input>
        <label class="label">รายการบริการ</label>
        <service-selector
          v-model="services"
          :disabled="disabled"
          class="input"
        ></service-selector>
      </div>
    </div>
    <image-picker-modal
      v-bind="chooseImageDialog"
      @cancel="handleCancelChooseImageDialog"
      @confirm="handleConfirmChooseImageDialog"
    ></image-picker-modal>
  </div>
</template>

<script>
import { Input } from "element-ui"
import ScButton from "@/lib/components/ScButton"
import ImagePickerModal from "@/lib/components/ImagePickerModal"
import ServiceSelector from "@/lib/components/ServiceSelector/ServiceSelector"

export default {
  components: {
    ScButton,
    ImagePickerModal,
    ServiceSelector,
    "el-input": Input,
  },
  props: {
    value: {
      type: null,
      default: undefined,
    },
    iconUrl: {
      type: null,
      default: undefined,
    },
    disabled: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {
      isShowModal: false,
    }
  },
  computed: {
    name: {
      get() {
        return this.value && this.value.name
      },
      set(name) {
        this.$emit("input", { ...this.value, name })
      },
    },
    services: {
      get() {
        return this.value && this.value.services
      },
      set(services) {
        this.$emit("input", { ...this.value, services })
      },
    },
    modalImageUrl() {
      if (!this.chooseImageDialog.thumbnailUrl) {
        return "https://placehold.co/300"
      }

      return this.chooseImageDialog.thumbnailUrl
    },
    chooseImageDialog() {
      return {
        isShow: this.isShowModal,
        isLoading: false,
        canEdit: true,
        title: "เลือกรูป Icon",
        width: 300,
        height: 300,
        recommendWidth: 300,
        recommendHeight: 300,
        thumbnailFile: this.value.iconFile,
        thumbnailUrl: this.iconUrl,
      }
    },
  },
  methods: {
    handleClickChooseImageButton() {
      this.isShowModal = true
    },
    handleCancelChooseImageDialog() {
      this.isShowModal = false
    },
    handleConfirmChooseImageDialog(file) {
      this.$emit("input", { ...this.value, iconFile: file })
      this.isShowModal = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.package-editor {
  .thumbnail-button {
    display: block;
    width: 100%;
  }
}

.image-container {
  flex: 0 0 225px;
  width: 225px;
}

.info-editor {
  max-width: calc(100% - 225px);
}

.label {
  margin-bottom: 5px;
  display: block;

  line-height: 1.6;
  font-size: 1rem;
  font-weight: bold;
}

.input {
  margin-bottom: 20px;

  &.quota {
    width: 80px;
  }
}

.input > textarea {
  min-height: 120px;
}

.thumbnail,
.image {
  margin-bottom: 20px;

  border-radius: $border-radius;
  border: $border;
  width: 100%;
}

.target-option {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .image {
    margin-right: 20px;

    border-radius: $border-radius;
    width: 24px;
    height: 24px;
  }
}

.target-select {
  width: 100%;
}
</style>
